import { notification } from "antd";
import { ArgsProps } from "antd/lib/notification";
import "./index.scss";

type NotificationType = "success" | "info" | "warning" | "error" | "delete";

const showNotification = (
  type: NotificationType,
  message: string,
  description = null
) => {
  let icon = null;
  switch (type) {
    case "success":
      break;
    case "error":
      break;
    case "delete":
      type = "info";
      break;
    default:
      break;
  }

  const config: ArgsProps = {
    message: message,
    description: description,
    placement: "top",
  };

  if (icon) {
    config.icon = icon;
  }

  notification[type](config);
};

export default showNotification;
